export default "__VITE_ASSET__BpPCyECp__"